import React, { useState, useEffect } from "react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { Link, useNavigate, Outlet } from "react-router-dom";
import "../pages/all css/subdropdown.css";

function DropDownBtn({ colorChange, fromPage }) {
  const [showDropDown, setShowDropDown] = useState(false);
  const [dropDownButton, setDropDownButton] = useState("");
  const [clicked, setClicked] = useState(false);
  const [careerFlag, setCareerFlag] = useState(false);
  const [bookFlag, setBookFlag] = useState(false);
  const [counsellingFlag, setCounsellingFlag] = useState(false);

  const navigate = useNavigate();

  const handleShowDropDown = () => {
    console.log("line 9");
  };

  const handleCloseDropDown = (data) => {
    console.log(data);
    setClicked(!clicked);
    setDropDownButton(data);
    // if (data === dropDownButton) {
    //   setClicked(false);
    //   setDropDownButton(data);
    // } else {
    //   setClicked(true);
    //   setDropDownButton(data);
    // }

    setShowDropDown(!showDropDown);
  };

  const handleBlogDropDown = () => {
    setShowDropDown(false);
    window.open("https://ielts.dynamicwec.net");
  };
  return (
    <li
      className={
        showDropDown ? "drop_down_container_li" : "drop_down_container_li1"
      }
    >
      <div className="dropdown1">
        <button
          className={
            colorChange || fromPage !== "home"
              ? "nav_change_color_text bg_transp"
              : "nav_link_text buton_nav"
          }
          onClick={() => setShowDropDown(!showDropDown)}
        >
          Ask DWEC
          {showDropDown ? (
            <MdArrowDropUp className="drop_down_btn" />
          ) : (
            <MdArrowDropDown className="drop_down_btn" />
          )}
        </button>

        {showDropDown ? (
          <div className="dropdown-content" onMouseLeave={handleCloseDropDown}>
            <button
              className={
                bookFlag
                  ? "nav_link_under_text nav_link main_text_title "
                  : "nav_link_under_text nav_link main_text_title  "
              }
              onClick={() => setBookFlag(!bookFlag)}
            >
              Study Abroad Counselling
            </button>

            <button
              className={
                careerFlag
                  ? "nav_link_under_text nav_link main_text_title up_chevron"
                  : "nav_link_under_text nav_link main_text_title down_chevron  "
              }
              onClick={() => setCareerFlag(!careerFlag)}
            >
              Career Counselling
            </button>
            {careerFlag ? (
              <>
                {" "}
                <button
                  id="studyabroad"
                  className="nav_link_under_text text_indent_text nav_link"
                  onClick={() =>
                    window.open("https://assessment.dynamicwec.net", "_blank")
                  }
                >
                  Persona Classifier
                </button>
                <button
                  className={
                    counsellingFlag
                      ? "nav_link_under_text nav_link text_indent_text  "
                      : "nav_link_under_text nav_link text_indent_text   "
                  }
                  // className="nav_link_under_text down_chevron text_indent_text  nav_link "
                  onClick={() => {
                    setCounsellingFlag(!counsellingFlag);
                    window.open("https://brainwave.dynamicwec.net", "_blank");
                  }}
                >
                  Brainwave Assessment
                </button>
              </>
            ) : null}
            {/* {counsellingFlag ? (
                  <>
                    {" "}
                    <button
                      className="nav_link_under_text text_indent_text nav_link third_drop"
                      onClick={() =>
                        window.open(
                          "https://assessment.dynamicwec.net",
                          "_blank"
                        )
                      }
                    >
                      Personality Assessment
                    </button>
                    <button
                      className="nav_link_under_text text_indent_text nav_link third_drop "
                      onClick={() =>
                        window.open(
                          "https://brainwave.dynamicwec.net",
                          "_blank"
                        )
                      }
                    >
                      Brainwave Assessment
                    </button>
                  </>
                ) : null}
              </>
            ) : null} */}
          </div>
        ) : null}
      </div>
    </li>
  );
}

export default DropDownBtn;
